module.exports = __webpack_public_path__ + "img/borderWavesBlue.45f68f46.svg";